import { SHIFT_ALLOWANCE } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';
import { appendServiceNameToURL, appendServicePortToURL } from '../resources/serviceURLs';
import UseAxios from '../http/http';

const defaultHeaders = { 'Content-Type': 'application/json' };

const request = (url, method = 'get', payload = null) => ({
  url,
  method,
  payload,
  headers: { ...defaultHeaders },
  service: serviceName.PROJECT_MS,
  authRequired: true,
  csrfToken: true,
});

export const getShiftAllowanceBaseURL = () => {
  const servicePath = appendServiceNameToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${servicePath}/api${SHIFT_ALLOWANCE}`;
  }

  return `${baseUrl}:${appendServicePortToURL(serviceName.PROJECT_MS)}${servicePath}/api${SHIFT_ALLOWANCE}`;
};

export const fetchShiftAllowanceEmployees = () => (
  UseAxios(request(`${SHIFT_ALLOWANCE}/employees`))
);

export const createShiftAllowanceDetail = (payload) => (
  UseAxios(request(`${SHIFT_ALLOWANCE}/details`, 'post', payload))
);

export const updateShiftAllowanceDetail = (id, payload) => (
  UseAxios(request(`${SHIFT_ALLOWANCE}/details/${id}`, 'put', payload))
);

export const deleteShiftAllowanceDetail = (id) => (
  UseAxios(request(`${SHIFT_ALLOWANCE}/details/${id}`, 'delete', {}))
);

export const uploadShiftAllowanceDetails = (payload) => (
  UseAxios(request(`${SHIFT_ALLOWANCE}/details/upload`, 'post', payload))
);

export const submitShiftAllowanceApproval = (payload) => (
  UseAxios(request(`${SHIFT_ALLOWANCE}/submit`, 'post', payload))
);

export const updateShiftAllowanceApproval = (requestId, payload) => (
  UseAxios(request(`${SHIFT_ALLOWANCE}/approval/${requestId}`, 'post', payload))
);
